/*eslint-disable*/
import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'semantic-ui-react';

import { LOCAL_STORAGE } from '../utils/constants';

const CityDropdown = ({
    field: { name },
    form: { setFieldValue },
    cityId,
    stateName,
    ...props
}) => {

    const [city, setCity] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    // useEffect(() => {
    //     if (city.length > 0 && stateName !== undefined && stateName !== null) {
    //         city.map((object) => {
    //             if (object.city_id == cityId) {
    //                 setFieldValue(stateName, object.stateName)
    //             }
    //         })
    //     }
    // }, [cityId])


    useEffect(() => {
        if (cityId) {
            setIsLoading(true)
            let token = LOCAL_STORAGE.userToken;
            let userId = LOCAL_STORAGE.userId;
            let customerNo = LOCAL_STORAGE.customerNo;
            let data = JSON.stringify
                ({
                    "customerNumber": customerNo,
                    "userId": userId,
                    "customer_no": customerNo,
                    "user_id": userId,
                    "customerNo": customerNo,
                    "city_id": cityId
                })

            Axios.post(`${process.env.REACT_APP_BASE_URL}/masters/cityMaster/`, data, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                setCity(response.data.resultSet)
                setIsLoading(false)
            }))
                .catch(error => {
                    console.log(error)
                    setIsLoading(false)
                })

        }
    }, [])

    let options = []
    if (city && city.length > 0) {
        city.map((object, index) => {
            let temp = {}
            temp.key = object.city_id
            temp.text = object.cityName
            temp.value = object.city_id
            temp.raw = object
            return options[index] = temp
        })
    }

    const handleSearchDropdown = (e, { searchQuery }) => {
        setIsLoading(true)
        let token = LOCAL_STORAGE.userToken;
        let userId = LOCAL_STORAGE.userId
        let customerNo = LOCAL_STORAGE.customerNo
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo,
                "searchTerm": searchQuery
            })

        Axios.post(`${process.env.REACT_APP_BASE_URL}/masters/cityMaster/`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            let city_master = response.data.resultSet
            if(city_master.length > 0 && props.stateFilterId){
                city_master = city_master.filter((city)=> city.stateId === props.stateFilterId)
            }
            city_master.length > 0 ? setCity(city_master):setCity([])
            setIsLoading(false)
        }))
            .catch(error => console.log(error))
        setIsLoading(false)

    }

    const onChangeCity = (e, data) => {
        setFieldValue(name, data.value)
        if(stateName){
            let city_master = options.find((city)=> city.value === data.value)?.raw
            console.log(city,'rowdata');
            if(city_master){
                setFieldValue(stateName, city_master.stateName)
            }
        }
    }

    return (
        <Dropdown
            selection
            search
            onChange={(e, data) => onChangeCity(e, data)}
            onSearchChange={(handleSearchDropdown)}
            options={options}
            clearable
            loading={isLoading}
            {...props}
        />

    )
}

export default CityDropdown